import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_BASE_URL } from './tokens';
import { Observable } from 'rxjs';
import { BackendResponse } from '@schenck/rotec-components';
import { Modules, SoftwareVersion } from '../utils/models/software.model';

@Injectable()
export class SoftwareApi {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  private readonly modulesUrl: string;

  constructor() {
    const baseUrl = this.baseUrl;

    this.modulesUrl = baseUrl + '/software';
  }

  public getSoftwareModules$(): Observable<BackendResponse.Response<Modules>> {
    return this.http
      .get<Modules>(this.modulesUrl + '/modules')
      .pipe(BackendResponse.mapToResponse());
  }

  public getSoftwareVersions$(): Observable<SoftwareVersion[]> {
    return this.http.get<SoftwareVersion[]>(this.modulesUrl + '/versions');
  }

  public getSoftwareLicenses$(): Observable<string[]> {
    return this.http.get<string[]>(this.modulesUrl + '/licenses');
  }
}
